import React, { useState, useRef, useEffect } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Avatar,
    Chip,
    Tooltip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
    IconButton,
} from "@mui/material";
import LogoIcon from "../../../assets/images/logo-icon.png";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import variables from "../../../assets/styles/variables.module.scss";
import TypingIndicator from "../../../Shared-ui/SharedComponents/TypingIndicator";
import LineMdAccount from "../../../assets/icons/LineMdAccount";
import { Params, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
    StartLoading,
    StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { AgentTheme } from "../../../Shared-ui/Types/Agent";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import PlayGroundInitialMessage from "../../Components/PlayGroundIntialMessage";
import { Message, UserMessage } from "../../../Shared-ui/Types/PlayGround";
import { v4 as uuidv4 } from "uuid";
import { PlayGroundEnum } from "../../../Shared-ui/Enum/PlayGroundEnum";
import { marked } from "marked";
import AgentPlayGroundTools from "../../Components/AgentPlayGroundTools";
import AgentPlaygroundReferences from "../../Components/AgentPlaygroundReferences";
import AgentQuestions from "../../Components/AgentQuestions";
import CachedIcon from "@mui/icons-material/Cached";
import AgentPrompts from "../../Components/AgentPromts";
import { capitalizeFirstLetter } from "../../../Shared-ui/utils/Common/Common";
import striptags from "striptags";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import NewChatIcon from "@mui/icons-material/Add";
import RecentChatIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RecentChatsByUser from "../../Components/RecentsChatsByUser";
import EndChatIcon from "../../../assets/icons/EndChatIcon";
import { AGENT_SHORTCUT, CHAT_HISTORY, CHAT_HISTORY_DETAIL, WORKFLOW } from "../../../Services/Endpoint";


const IFrameWorkFlow: React.FC = () => {
    const { workflowId, apiKey } = useParams<Params>();

    const dispatch = useDispatch();
    const uniqueId = uuidv4();
    const [intialMessage, setIntialMessage] = useState<string>("");
    const [workflow, setWorkflow] = useState<any>();
    const [userInput, setUserInput] = useState<string>("");
    const [botTyping, setBotTyping] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [messages, setMessages] = useState<Message[]>([]);
    const endOfMessagesRef = useRef<HTMLDivElement>(null);
    const [conversationId, setConversationId] = useState<string>("");
    const [showQuestions, setShowQuestions] = useState<boolean>(true);
    const [showInitialMessage, setShowInitialMessage] = useState(true);
    const [incomingTextColor, setIncomingTextColor] = useState("#000000");
    const [agentShortcuts, setAgentShortcuts] = useState<any>([]);
    const [showCitations, setShowCitations] = useState<boolean>(false);
    const [pageContext, setPageContext] = useState<{
        html: string;
        url: string;
        title: string;
    } | null>(null);
    const [userContext, setUserContext] = useState<any>(null);
    const [userId, setUserId] = useState<string | null>("");
    const [guestUserId, setGuestUserId] = useState<string | null>("");
    const [chatHistoryId, setChatHistoryId] = useState<string>("");
    console.log(chatHistoryId, "chatHistoryId workflow");

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [showHistory, setShowHistory] = useState<boolean>(false);
    const [chatHistories, setChatHistories] = useState<any[]>([]);
    console.log(chatHistories, "chatHistories workflow");

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [pageSize] = useState<number>(10);
    const isCancelledStream = useRef<boolean>(true);

    const [agentTheme, setAgentTheme] = useState<AgentTheme>({
        backgroundColor: "#ffffff",
        titleColor: "#000000",
        outgoingChatTextColor: "#000000",
        incomingChatTextColor: "#000000",
        chatBubbleButtonColor: variables.primaryColor,
        mode: "single",
        angle: 180
    });
    const responseId = useRef<string>("");


    // Debug: Log when pageContext changes
    useEffect(() => {
        if (pageContext) {
            console.log('📄 Page context updated in workflow iframe:', {
                title: pageContext.title,
                url: pageContext.url,
                htmlLength: pageContext.html.length
            });
        } else {
            console.log('📄 Page context is null in workflow iframe');
        }
    }, [pageContext]);

    // Debug: Log when userContext changes
    useEffect(() => {
        if (userContext) {
            console.log('👤 User context updated in workflow iframe:', userContext);
            setUserId(userContext.id);
            console.log(userId, "userId loaded");
        } else {
            console.log('👤 User context is null in workflow iframe');
        }
    }, [userContext]);

    useEffect(() => {
        const scrollBehavior = botTyping ? "auto" : "smooth";
        endOfMessagesRef.current?.scrollIntoView({ behavior: scrollBehavior });
    }, [messages.length, botTyping]);

    useEffect(() => {
        getWorkflow();
        getAgentShortCut();
    }, [workflowId]);

    useEffect(() => {
        if (!botTyping) {
            inputRef.current?.focus();
        }
    }, [messages, botTyping]);

    // Listen for post messages from parent window
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            console.log('🔄 Workflow iframe received message:', event.data);

            // Verify the message is from the expected origin (parent window)
            // Allow null origin for local file system and localhost origins
            if (event.origin !== window.location.origin &&
                event.origin !== 'null' &&
                !event.origin.includes('localhost') &&
                event.origin !== '') {
                console.log('⚠️ Message origin not trusted:', event.origin);
                return;
            }

            if (event.data.type === 'PAGE_CONTENT') {
                console.log('✅ Received page content from parent:', {
                    html: event.data.html,
                    url: event.data.url,
                    title: event.data.title
                });

                // Store the page content in state for use in chat
                const newPageContext = {
                    html: event.data.html,
                    url: event.data.url,
                    title: event.data.title
                };

                console.log('📄 Setting pageContext to:', newPageContext);
                setPageContext(newPageContext);

                // Show visual feedback that page context was updated
                if (pageContext && pageContext.url !== newPageContext.url) {
                    console.log('🔄 Page context updated - user navigated to new page');
                }

                // Send confirmation back to parent window
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({
                        type: 'PAGE_CONTENT_RECEIVED',
                        message: 'Page content successfully received by workflow iframe',
                        data: {
                            html: event.data.html,
                            url: event.data.url,
                            title: event.data.title
                        }
                    }, '*');
                    console.log('✅ Confirmation sent back to parent');
                }
            } else if (event.data.type === 'USER_DATA') {
                console.log('✅ Received user data from parent:', event.data.data);

                // Store the user data in state for use in chat
                setUserContext(event.data.data);
                console.log('📊 User data received in workflow iframe:', event.data.data);

                // Send confirmation back to parent window
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({
                        type: 'USER_DATA_RECEIVED',
                        message: 'User data successfully received by workflow iframe',
                        data: event.data.data
                    }, '*');
                    console.log('✅ User data confirmation sent back to parent');
                }
            } else if (event.data.type === 'REQUEST_GUEST_USER_DATA') {
                console.log('👤 Received request for guest user data generation in workflow iframe');

                // Generate guest user data
                const guestUserId = crypto.randomUUID();
                const guestUserData = {
                    id: guestUserId,
                    name: 'Guest User',
                    email: `${guestUserId}@dummy.zeaiq.com`,
                    type: 'guest',
                    timestamp: new Date().toISOString()
                };

                console.log('👤 Generated guest user data:', guestUserData);

                // Set the local state so API requests will include user context
                setUserContext(guestUserData);
                setUserId(guestUserId);

                // Send the generated guest user data back to parent window
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({
                        type: 'GUEST_USER_DATA_GENERATED',
                        message: 'Guest user data successfully generated by workflow iframe',
                        data: guestUserData
                    }, '*');
                    console.log('✅ Guest user data sent back to parent');
                }
            } else if (event.data.type === 'CHAT_HISTORY_ID') {
                console.log('📚 Received chat history ID from parent:', event.data.data);

                // Set the chat history ID from parent window
                const { workflowId: wfId, userId: uId, chatHistoryId: chId } = event.data.data;
                if (wfId && uId && chId) {
                    setChatHistoryId(chId);
                    console.log('📚 Set chat history ID from parent:', chId);
                }
            } else {
                console.log('ℹ️ Received message with type:', event.data.type);
            }
        };

        console.log('🔄 Setting up message listener in workflow iframe');
        window.addEventListener('message', handleMessage);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const getWorkflow = async () => {
        try {
            dispatch(StartLoading());
            const response = await fetch(`${WORKFLOW.GET_WORKFLOWS}/${workflowId}`, {
                method: "GET",
                headers: {
                    "x-api-key": `${apiKey}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                mode: "cors",
                credentials: "same-origin",
            });
            const data = await response.json();
            setIntialMessage(`Hello! How can I assist you today?`);
            setWorkflow(data);
            // Workflows don't have agent_theme like agents/teams, using default
            // If workflows support themes in the future, update this line
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail || "Failed to load workflow"));
        } finally {
            dispatch(StopLoading());
        }
    };

    const getAgentShortCut = async () => {
        try {
            dispatch(StartLoading());
            const response = await fetch(`${AGENT_SHORTCUT}`, {
                method: "GET",
                headers: {
                    "x-api-key": `${apiKey}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                mode: "cors",
                credentials: "same-origin",
            });
            const data = await response.json();
            setAgentShortcuts(data || []);
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.statusText || "Failed to load shortcuts"));
        } finally {
            dispatch(StopLoading());
        }
    };

    const sendMessageShortcuts = async (shortcut: string, messageId: number) => {
        isCancelledStream.current = false;
        setShowQuestions(false);

        // Check if userContext is available, if not, generate a guest user
        if (!userContext) {
            console.log('👤 No user context available, generating guest user for shortcut');
            const guestUserId = crypto.randomUUID();
            const guestUserData = {
                id: guestUserId,
                name: 'Guest User',
                email: `${guestUserId}@dummy.zeaiq.com`,
                type: 'guest',
                timestamp: new Date().toISOString()
            };
            setUserContext(guestUserData);
            setUserId(guestUserId);

            // Notify parent window about guest user generation
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    type: 'GUEST_USER_GENERATED',
                    message: 'Guest user generated for shortcut',
                    data: guestUserData
                }, '*');
            }
        }

        const message = messages[messageId];
        const plainText = striptags(message.agentData?.response || "");

        // Create the input for workflow with action instruction
        const inputText = `${capitalizeFirstLetter(shortcut)}: ${plainText}`;

        const data: UserMessage = {
            input: inputText,
            conversation_id: conversationId ? conversationId : "",
        };

        // Create the request payload for the API
        const requestPayload = {
            input: inputText,
            conversation_id: conversationId ? conversationId : "",
            chat_history_id: chatHistoryId || undefined,
            metadata: {
                action: shortcut,
                original_content: plainText,
                ...(pageContext && { page_context: pageContext }),
                ...(userContext && { user_context: userContext })
            }
        };

        console.log('🔄 Sending shortcut action:', shortcut);

        // Add user message showing the action
        setMessages((prev) => [
            ...prev,
            { sender: PlayGroundEnum.USER, userData: { ...data, input: `<i>${capitalizeFirstLetter(shortcut)}</i>` } },
        ]);
        setUserInput("");
        setBotTyping(true);

        try {
            const response = await fetch(
                `${WORKFLOW.EXECUTE_WORKFLOW}/${workflowId}/execute`,
                {
                    method: "POST",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(requestPayload),
                    mode: "cors",
                    credentials: "same-origin",
                }
            );

            if (!response.ok) {
                throw new Error("Failed to execute workflow shortcut");
            }

            const responseData = await response.json();
            console.log('📥 Received workflow shortcut response:', responseData);

            // Extract the content from the response
            let content = "";
            if (responseData.output && responseData.output.content) {
                content = responseData.output.content;
            } else if (responseData.response) {
                content = responseData.response;
            } else {
                console.error("Unexpected response format:", responseData);
                content = "Sorry, I received an unexpected response format.";
            }

            // Parse markdown content
            const sanitizedContent = await marked.parse(content);

            // Update conversation ID if present
            if (responseData.conversation_id) {
                setConversationId(responseData.conversation_id);
            }

            // Update chat history ID if present
            if (responseData.chat_history_id) {
                setChatHistoryId(responseData.chat_history_id);
                console.log('📚 Received chat history ID from shortcut response:', responseData.chat_history_id);
            }

            // Update response ID if present (for feedback)
            if (responseData.response_id) {
                responseId.current = responseData.response_id;
            }

            // Add agent message with the content
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: sanitizedContent,
                        rawResponse: content,
                        conversation_id: responseData.conversation_id || "",
                        response_id: responseData.response_id || ""
                    }
                }
            ]);

        } catch (err) {
            console.error("Workflow shortcut execution failed:", err);
            // Add error message to chat
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: "Sorry, something went wrong. Please try again.",
                        conversation_id: ""
                    }
                }
            ]);
        } finally {
            setBotTyping(false);
        }
    };

    const sendMessageQuestions = async (question: string) => {
        isCancelledStream.current = false;
        setShowInitialMessage(false);
        setShowQuestions(false);

        // Check if userContext is available, if not, generate a guest user
        if (!userContext) {
            console.log('👤 No user context available, generating guest user for question');
            const guestUserId = crypto.randomUUID();
            const guestUserData = {
                id: guestUserId,
                name: 'Guest User',
                email: `${guestUserId}@dummy.zeaiq.com`,
                type: 'guest',
                timestamp: new Date().toISOString()
            };
            setUserContext(guestUserData);
            setUserId(guestUserId);

            // Notify parent window about guest user generation
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    type: 'GUEST_USER_GENERATED',
                    message: 'Guest user generated for question',
                    data: guestUserData
                }, '*');
            }
        }

        const data: UserMessage = {
            input: question,
            conversation_id: conversationId ? conversationId : "",
        };

        // Debug: Show current userContext state
        console.log('👤 Current userContext before creating payload:', userContext);
        console.log('👤 Current userId before creating payload:', userId);

        // Create the request payload for the API
        const requestPayload = {
            input: question,
            conversation_id: conversationId ? conversationId : "",
            chat_history_id: chatHistoryId || undefined,
            metadata: {
                ...(pageContext && { page_context: pageContext }),
                ...(userContext && { user_context: userContext })
            }
        };

        console.log('📤 Sending question with payload:', requestPayload);
        console.log('📄 Page context available:', !!pageContext);
        console.log('📄 Page context value:', pageContext);
        console.log('👤 User context available:', !!userContext);
        console.log('👤 User context value:', userContext);
        userContext?.id && console.log('👤 User ID:', userContext.id);

        console.log('📄 Request payload JSON:', JSON.stringify(requestPayload, null, 2));

        // Add user message
        setMessages((prev) => [
            ...prev,
            { sender: PlayGroundEnum.USER, userData: data },
        ]);
        setUserInput("");
        setBotTyping(true);

        try {
            const response = await fetch(
                `${WORKFLOW.GET_WORKFLOWS}/${workflowId}/execute`,
                {
                    method: "POST",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(requestPayload),
                    mode: "cors",
                    credentials: "same-origin",
                }
            );

            if (!response.ok) {
                throw new Error("Failed to execute workflow");
            }

            const data = await response.json();
            console.log('📥 Received workflow response:', data);

            // Extract the content from the response
            let content = "";
            if (data.output && data.output.content) {
                content = data.output.content;
            } else if (data.response) {
                // Fallback to 'response' field if output structure is not present
                content = data.response;
            } else {
                console.error("Unexpected response format:", data);
                content = "Sorry, I received an unexpected response format.";
            }

            // Parse markdown content
            const sanitizedContent = await marked.parse(content);

            // Update conversation ID if present
            if (data.conversation_id) {
                setConversationId(data.conversation_id);
            }

            // Update chat history ID if present
            if (data.chat_history_id) {
                setChatHistoryId(data.chat_history_id);
                console.log('📚 Received chat history ID from workflow response:', data.chat_history_id);
            }

            // Update response ID if present (for feedback)
            if (data.response_id) {
                responseId.current = data.response_id;
            }

            // Add agent message with the content
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: sanitizedContent,
                        rawResponse: content,  // Store raw content for copy functionality
                        conversation_id: data.conversation_id || "",
                        response_id: data.response_id || ""
                    }
                }
            ]);

        } catch (err) {
            console.error("Workflow execution failed:", err);
            // Add error message to chat
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: "Sorry, something went wrong. Please try again.",
                        conversation_id: ""
                    }
                }
            ]);
        } finally {
            setBotTyping(false);
        }
    };

    const sendMessage = async () => {
        isCancelledStream.current = false;
        if (!userInput.trim()) return;

        // Check if userContext is available, if not, generate a guest user
        if (!userContext) {
            console.log('👤 No user context available, generating guest user');
            const guestUserId = crypto.randomUUID();
            const guestUserData = {
                id: guestUserId,
                name: 'Guest User',
                email: `${guestUserId}@dummy.zeaiq.com`,
                type: 'guest',
                timestamp: new Date().toISOString()
            };
            setUserContext(guestUserData);
            setUserId(guestUserId);

            // Notify parent window about guest user generation
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    type: 'GUEST_USER_GENERATED',
                    message: 'Guest user generated for chat',
                    data: guestUserData
                }, '*');
            }
        }

        setShowInitialMessage(false);
        setShowQuestions(false);
        const data: UserMessage = {
            input: userInput,
            conversation_id: conversationId ? conversationId : "",
        };

        // Create the request payload for the API
        const requestPayload = {
            input: userInput,
            conversation_id: conversationId ? conversationId : "",
            chat_history_id: chatHistoryId || undefined,
            metadata: {
                ...(pageContext && { page_context: pageContext }),
                ...(userContext && { user_context: userContext })
            }
        };

        console.log('📤 Sending message with payload:', requestPayload);

        // Add user message
        setMessages((prev) => [
            ...prev,
            { sender: PlayGroundEnum.USER, userData: data },
        ]);
        setUserInput("");
        setBotTyping(true);

        try {
            const response = await fetch(
                `${WORKFLOW.EXECUTE_WORKFLOW}/${workflowId}/execute`,
                {
                    method: "POST",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(requestPayload),
                    mode: "cors",
                    credentials: "same-origin",
                }
            );

            if (!response.ok) {
                throw new Error("Failed to execute workflow");
            }

            const data = await response.json();
            console.log('📥 Received workflow response:', data);

            // Extract the content from the response
            let content = "";
            if (data.output && data.output.content) {
                content = data.output.content;
            } else if (data.response) {
                // Fallback to 'response' field if output structure is not present
                content = data.response;
            } else {
                console.error("Unexpected response format:", data);
                content = "Sorry, I received an unexpected response format.";
            }

            // Parse markdown content
            const sanitizedContent = await marked.parse(content);

            // Update conversation ID if present
            if (data.conversation_id) {
                setConversationId(data.conversation_id);
            }

            // Update chat history ID if present
            if (data.chat_history_id) {
                setChatHistoryId(data.chat_history_id);
                console.log('📚 Received chat history ID from workflow response:', data.chat_history_id);
            }

            // Update response ID if present (for feedback)
            if (data?.output?.response_id) {
                responseId.current = data.output.response_id;
            }

            // Add agent message with the content
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: sanitizedContent,
                        rawResponse: content,  // Store raw content for copy functionality
                        conversation_id: data.conversation_id || "",
                        response_id: data?.output?.response_id || ""
                    }
                }
            ]);

        } catch (err) {
            console.error("Workflow execution failed:", err);
            // Add error message to chat
            setMessages((prev) => [
                ...prev,
                {
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: "Sorry, something went wrong. Please try again.",
                        conversation_id: ""
                    }
                }
            ]);
        } finally {
            setBotTyping(false);
        }
    };

    const clearChat = () => {
        isCancelledStream.current = true;
        setShowHistory(false);
        setMessages([]);
        setUserInput("");
        setBotTyping(false);
        setShowInitialMessage(true);
        setShowQuestions(true);
        setConversationId("");
        setChatHistoryId("");
        const newUniqueId = uuidv4();
        console.log('🆕 New chat started with ID:', newUniqueId);
    };

    const handleClickDots = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleViewRecentChats = async () => {
        setShowHistory(true);
        handleClose();
        await fetchChatHistories(1);
    };

    const handleStartNewChat = () => {
        setShowHistory(false);
        clearChat();
        handleClose();
    };

    const handleEndChat = () => {
        clearChat();
        handleClose();
    };

    const handleBackToChat = () => {
        setShowHistory(false);
        setChatHistories([]);
        setCurrentPage(1);
    };

    const handlePageChange = async (page: number) => {
        setCurrentPage(page);
        await fetchChatHistories(page);
    };

    const fetchChatHistories = async (page: number) => {
        try {
            const response = await fetch(`${CHAT_HISTORY}?user_id=${userId || guestUserId}&page=${page}&page_size=${pageSize}&agent_id=${workflowId}`, {
                method: "GET",
                headers: {
                    "x-api-key": `${apiKey}`,
                    "Content-Type": "application/json",
                },
                mode: "cors",
                credentials: "same-origin",
            });

            if (response.ok) {
                const data = await response.json();
                setChatHistories(data.items || []);
                setTotalPages(data.pagination?.total_pages || 1);
            } else {
                console.error('Failed to fetch chat histories');
                setChatHistories([]);
            }
        } catch (error) {
            console.error('Error fetching chat histories:', error);
            setChatHistories([]);
        }
    };

    const handleChatHistorySelect = async (chatData: any) => {
        console.log('📚 Chat data received:', chatData);

        try {
            dispatch(StartLoading());

            let chatId = chatData?.id || chatData?.chat_history_id || chatData;

            if (!chatId) {
                console.error('❌ Chat ID is undefined:', chatData);
                return;
            }

            console.log('🔍 Using chat ID:', chatId);

            const response = await fetch(
                `${CHAT_HISTORY_DETAIL}/${chatId}/detail`,
                {
                    method: "GET",
                    headers: {
                        "x-api-key": `${apiKey}`,
                        "Content-Type": "application/json",
                    },
                    mode: "cors",
                    credentials: "same-origin",
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch chat history details");
            }

            const chatDetails = await response.json();
            setConversationId(chatDetails.conversation_id);

            const convertedMessages: Message[] = [];

            for (const msg of chatDetails.messages) {
                convertedMessages.push({
                    sender: PlayGroundEnum.USER,
                    userData: {
                        input: msg.user_message,
                        conversation_id: msg.agent_response.conversation_id,
                    },
                });

                const parsedResponse = await marked.parse(msg.agent_response.response);
                convertedMessages.push({
                    sender: PlayGroundEnum.AGENT,
                    agentData: {
                        response: parsedResponse,
                        rawResponse: msg.agent_response.response,  // Store raw content for copy functionality
                        metadata: {
                            tool_calls: msg.agent_response.metadata.tool_calls || [],
                            extra_data: msg.agent_response.metadata.extra_data || {},
                        },
                    },
                });
            }

            setMessages(convertedMessages);
            setShowInitialMessage(false);
            setShowQuestions(false);
            setShowHistory(false);
            setChatHistoryId(chatId);

            console.log('📚 Loaded chat history details:', {
                conversationId: chatDetails.conversation_id,
                messageCount: chatDetails.message_count,
                messages: convertedMessages.length
            });

        } catch (error) {
            console.error("Error loading chat history details:", error);
        } finally {
            dispatch(StopLoading());
        }
    };

    return (
        <Box
            sx={{ width: "100vw", height: "100vh", p: 0, m: 0, background: "#fff" }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    width: "100vw",
                    marginLeft: 0,
                    marginRight: 0,
                    borderColor: "rgba(24, 24, 27, .1)",
                    borderRadius: "30px",
                    background: agentTheme.backgroundColor,
                    overflow: "hidden",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                }}
            >
                {/* Header */}
                <Box
                    position="sticky"
                    sx={{
                        background: agentTheme.backgroundColor,
                        borderBottom: "1px solid #f9f7f7",
                        px: 4,
                        py: 1.5,
                        display: showHistory ? "none" : "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 15px 30px 0 rgba(256, 256, 256, 1)",
                        zIndex: 1,
                        top: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                            }}
                        >
                            <img
                                src={LogoIcon}
                                alt="Company Logo"
                                style={{ width: 30, height: "auto" }}
                            />
                        </Box>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1, textTransform: "capitalize", color: agentTheme.titleColor }}
                        >
                            {workflow?.name || workflow?.workflow_name || "Workflow Chat"}
                        </Typography>
                    </Box>

                    <Box>
                        <IconButton
                            id="demo-positioned-button"
                            aria-controls={open ? "demo-positioned-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={handleClickDots}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                                    borderRadius: 2,
                                },
                            }}
                        >
                            <MenuItem onClick={handleStartNewChat}>
                                <ListItemIcon>
                                    <NewChatIcon />
                                </ListItemIcon>
                                <ListItemText>Start a new chat</ListItemText>
                            </MenuItem>

                            <MenuItem onClick={handleEndChat}>
                                <ListItemIcon>
                                    <EndChatIcon />
                                </ListItemIcon>
                                <ListItemText>End chat</ListItemText>
                            </MenuItem>

                        </Menu>
                    </Box>
                </Box>

                {/* Chat Messages */}
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        height: "calc(100% - 130px)",
                        alignItems: showHistory ? "flex-start" : "center",
                        p: 0,
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: "100%",
                            overflow: "auto",
                            p: showHistory ? 0 : 4,
                            "&::-webkit-scrollbar": {
                                width: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "rgba(0, 0, 0, 0.2)",
                                borderRadius: "3px",
                            },
                        }}
                    >
                        {showHistory ? (
                            <RecentChatsByUser
                                historyData={{
                                    items: chatHistories,
                                    pagination: {
                                        total: totalPages,
                                        page: currentPage,
                                        perPage: 10,
                                    },
                                }}
                                onPageChange={handlePageChange}
                                onBack={handleBackToChat}
                                clearChat={clearChat}
                                onChatSelect={handleChatHistorySelect}
                            />
                        ) : (
                            <>
                                {showInitialMessage && (
                                    <PlayGroundInitialMessage
                                        message={intialMessage}
                                        incomingTextColor={agentTheme.incomingChatTextColor}
                                    />
                                )}
                            </>
                        )}

                        {messages.map((msg, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    mb: 3,
                                }}
                            >
                                <Box sx={{ width: "100%" }}>
                                    {/* Bot Message */}
                                    {msg.sender === PlayGroundEnum.AGENT ? (
                                        <Box sx={{ display: "flex" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    mr: 2,
                                                    height: "24px",
                                                }}
                                            >
                                                <img
                                                    src={LogoIcon}
                                                    alt="Company Logo"
                                                    style={{ width: 24, height: "auto" }}
                                                />
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                <Typography
                                                    key={index}
                                                    variant="body2"
                                                    component="div"
                                                    sx={{
                                                        color: agentTheme.incomingChatTextColor,
                                                        whiteSpace: "normal",
                                                        "& table": {
                                                            borderCollapse: "collapse",
                                                            width: "100%",
                                                            margin: "8px 0",
                                                        },
                                                        "& th, & td": {
                                                            border: "1px solid #bdbdbd",
                                                            padding: "6px 10px",
                                                        },
                                                        "& th": {
                                                            background: "#f5f5f5",
                                                            fontWeight: 600,
                                                        },
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: msg?.agentData?.response || "...",
                                                    }}
                                                />

                                                <AgentPrompts
                                                    agentShortuts={agentShortcuts}
                                                    messageId={index}
                                                    sendMessageShortcuts={sendMessageShortcuts}
                                                    incomingTextColor={incomingTextColor}
                                                    messages={messages}
                                                    setMessages={setMessages}
                                                    agentId={workflowId}
                                                    responseId={responseId.current}
                                                    conversationId={conversationId}
                                                    apiKey={apiKey}
                                                    useApiKey={true}
                                                />
                                            </Box>
                                        </Box>
                                    ) : (
                                        /* User Message */
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                gap: 2,
                                                mb: 2,
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: variables.primaryColor,
                                                    width: 24,
                                                    height: 24,
                                                }}
                                            >
                                                <LineMdAccount />
                                            </Avatar>
                                            <Typography
                                                variant="body2"
                                                component="div"
                                                sx={{
                                                    color: agentTheme.outgoingChatTextColor,
                                                    whiteSpace: "normal",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: msg?.userData?.input || "",
                                                }}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        ))}

                        {botTyping && <TypingIndicator />}

                        {showQuestions && (
                            <AgentQuestions
                                sendMessageQuestions={sendMessageQuestions}
                                agentId={workflowId}
                            />
                        )}

                        <div ref={endOfMessagesRef} />
                    </Box>
                </Box>

                {/* Input Section */}
                {!showHistory && (
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "flex-start",
                            p: 2,
                            bgcolor: "rgba(255, 255, 255, 0.2)",
                            width: "100%",
                            position: "sticky",
                            bottom: 0,
                            borderTop: "1px solid rgba(24, 24, 27, .1)",
                            flexDirection: "column",
                            background: agentTheme.backgroundColor,
                        }}
                    >
                        <Box
                            sx={{
                                border: "1px solid rgba(24, 24, 27, .1)",
                                boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                                borderRadius: "20px",
                                width: "100%",
                                position: "relative",
                                padding: "12px 16px",
                                background: "#fff",
                            }}
                        >
                            <TextField
                                fullWidth
                                multiline
                                variant="outlined"
                                size="small"
                                maxRows={4}
                                placeholder="Ask anything..."
                                value={userInput}
                                onChange={(e) => setUserInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        sendMessage();
                                    }
                                }}
                                inputRef={inputRef}
                                disabled={botTyping}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        fontSize: "14px",
                                        maxHeight: "120px",
                                        overflowY: "auto",
                                        pr: "40px",
                                        "&::-webkit-scrollbar": {
                                            width: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                                            borderRadius: "3px",
                                        },
                                        "& fieldset": {
                                            border: "none",
                                        },
                                        "&:hover fieldset": {
                                            border: "none",
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                            />
                            <Box
                                sx={{
                                    position: "absolute",
                                    bottom: "10px",
                                    right: "10px",
                                    display: "flex",
                                    gap: 1,
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    onClick={sendMessage}
                                    disabled={botTyping || !userInput}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        background: agentTheme.chatBubbleButtonColor,
                                        color: variables.whiteColor,
                                        minWidth: 0,
                                        borderRadius: "50%",
                                        "&.Mui-disabled": {
                                            color: variables.whiteColor,
                                            opacity: 0.5,
                                        },
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="none"
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M10 14L21 3m0 0l-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1z"
                                        />
                                    </svg>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default IFrameWorkFlow;
